<template>
  <div class="wrapper">
    <p class="wrapper_title">Ревит Буффер</p>
    <div class="header">
      <div class="filters__item" style="width: 140px;">
        <CustomInput label="Введите Code" :required="false" :value="filters.code"
          @change_input="(value) => onFiltersChange('code', value)" />
      </div>
      <div class="filters__item" style="width: 140px;">
        <CustomSelect :options="this.floor_field_1" label="Этаж (Base Constraint)" optionValueKey="value"
          optionLabelKey="label" :value="filters.floor_field_1"
          @change="(value) => onFiltersChange('floor_field_1', value)" />
      </div>
      <div class="filters__item" style="width: 140px;">
        <CustomSelect :options="this.floor_field_2" label="Этаж (BiLevel)" optionValueKey="value" optionLabelKey="label"
          :value="filters.floor_field_2" @change="(value) => onFiltersChange('floor_field_2', value)" />
      </div>
      <div class="filters__item" style="max-width: 350px; width: 100%;">
        <CustomSelect :options="this.wall_type_name" label="Тип стены" optionValueKey="value" optionLabelKey="label"
          :value="filters.wall_type_names" @change="(value) => onFiltersChange('wall_type_names', value)"
          :multiple="true" />
      </div>
    </div>
    <div class="content-layout">
      <div class="table-section">
        <div v-if="!isDataReadyToShow" class="placeholder-message">
          <p class="placeholder-text">
            {{ getPlaceholderMessage() }}
          </p>
        </div>

        <CustomTable v-else :rowsData="this.data" :columns="this.revitBufferParamsColumns" :loading="isFetching"
          :custom-body="true" :sticky-header="true" :page-header-height="150" :hide-top-title="true" :checkbox="true"
          :checkbox-value="allSelected" @all-check-click="onAllCheckClick" :bottom-row="true">
          <template #customBody="props">
            <q-tr>
              <custom-table-cell align="center" vertical-align="center">
                <CustomCheckbox :value="selectedRows.includes(props.row.floor_buffer_id)"
                  @change="(value) => onRowCheckClick(props.row.floor_buffer_id, value)" />
              </custom-table-cell>
              <custom-table-cell align="center" vertical-align="center">
                {{ props.row.index }}
              </custom-table-cell>
              <custom-table-cell align="left" vertical-align="center">
                <span>{{ props.row.floor_param_type_name }}</span>
              </custom-table-cell>
              <custom-table-cell align="center" vertical-align="center">
                <span>{{ props.row.floor_buffer_id }}</span>
              </custom-table-cell>
              <custom-table-cell align="left" vertical-align="center" style="width: 150px;">
                {{ props.row.wall_type_name }}
              </custom-table-cell>
              <custom-table-cell align="right" vertical-align="center">
                {{ props.row.volume }}
              </custom-table-cell>
              <custom-table-cell align="right" vertical-align="center">
                {{ props.row.area }}
              </custom-table-cell>
              <custom-table-cell align="right" vertical-align="center">
                {{ props.row.height.toFixed(3) }}
              </custom-table-cell>
              <custom-table-cell align="right" vertical-align="center">
                {{ props.row.wall_width.toFixed(3) }}
              </custom-table-cell>
              <custom-table-cell align="center" vertical-align="center">
                {{ props.row.floor_field_1 }}
              </custom-table-cell>
              <custom-table-cell align="center" vertical-align="center">
                {{ props.row.floor_field_2 }}
              </custom-table-cell>
              <custom-table-cell align="center" vertical-align="center">
                <q-tooltip>Посмотреть координаты</q-tooltip>
                <Clickable>
                  Посмотреть
                  <q-icon name="fa-solid fa-eye" />
                </Clickable>
                <q-popup-proxy ref="popupProxy">
                  <div class="popup-proxy">
                    <p>{{ props.row.param_geom }}</p>
                  </div>
                </q-popup-proxy>
              </custom-table-cell>
              <custom-table-cell align="center" vertical-align="center">
                {{ props.row.rowversion }}
              </custom-table-cell>
              <custom-table-cell align="left" vertical-align="center">
                {{ props.row.code }}
              </custom-table-cell>
            </q-tr>
          </template>
          <template #bottomRow
            v-if="totalsData && (totalsData.total_count || totalsData.total_volume || totalsData.total_area)">
            <q-tr style="background-color: #f5f5f5; font-weight: bold;">
              <custom-table-cell align="center" vertical-align="center">
                Итого:
              </custom-table-cell>
              <custom-table-cell align="center" vertical-align="center">
                {{ totalsData.total_count || 0 }}
              </custom-table-cell>
              <custom-table-cell align="left" vertical-align="center"></custom-table-cell>
              <custom-table-cell align="left" vertical-align="center"></custom-table-cell>
              <custom-table-cell align="center" vertical-align="center"></custom-table-cell>
              <custom-table-cell align="right" vertical-align="center">
                {{ totalsData.total_volume || 0 }}
              </custom-table-cell>
              <custom-table-cell align="right" vertical-align="center">
                {{ totalsData.total_area || 0 }}
              </custom-table-cell>
              <custom-table-cell align="center" vertical-align="center"></custom-table-cell>
              <custom-table-cell align="left" vertical-align="center"></custom-table-cell>
              <custom-table-cell align="left" vertical-align="center"></custom-table-cell>
              <custom-table-cell align="left" vertical-align="center"></custom-table-cell>
              <custom-table-cell align="left" vertical-align="center"></custom-table-cell>
              <custom-table-cell align="left" vertical-align="center"></custom-table-cell>
              <custom-table-cell align="left" vertical-align="center"></custom-table-cell>
            </q-tr>
          </template>
        </CustomTable>
      </div>
      <BufferSchemaView :bufferParams="selectedBufferParams" @refresh-data="refreshData" :savedFilters="this.filters"
        :rowsData="this.rowsData" @update-rows="applyNewRows" :selectedBufferParamsType="selectedBufferParamsType"
        :isRevit="true" />
    </div>
  </div>
</template>

<script>
import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";
import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import CustomCheckbox from "@/components/form/CustomCheckbox";
import CustomDate from "@/components/form/CustomDate";
import CustomSelect from "@/components/form/CustomSelect";
import CustomInput from "@/components/form/CustomInput";
import {
  revitBufferParamsColumns,
  getWallTypes,
  getRevitBufferParamsList,
  getFloorField1,
  getFloorField2
} from "@/views/RevitBufferParams/services";
import Filters from "../ResidentialSettings/filters.vue";
import BufferSchemaView from "@/views/BufferParams/BufferSchemaView.vue";
import Clickable from "@/components/common/Clickable";

export default {
  name: "RevitBufferParams",
  components: { CustomInput, CustomTableCell, CustomTable, CustomSelect, CustomDate, CustomCheckbox, BufferSchemaView, Filters, Clickable },
  data() {
    return {
      rowsData: [],
      totalsData: {},
      revitBufferParamsColumns,
      wall_type_name: [],
      floor_field_1: [],
      floor_field_2: [],
      wall_type_names: [],
      filters: {
        wall_type_names: [],
        floor_field_1: '',
        floor_field_2: '',
        code: ''
      },
      savedFilters: {},
      isFetching: false,
      selectedRows: [],
      allSelected: false,
      codeDebounceTimer: null,
    }
  },
  computed: {
    data() {
      return this.rowsData?.map((item, i) => ({ ...item, index: i + 1 }))
    },
    isDataReadyToShow() {
      const hasCode = !!this.filters.code;
      const hasFloor1 = !!this.filters.floor_field_1;
      const hasFloor2 = !!this.filters.floor_field_2;

      return hasCode && (hasFloor1 || hasFloor2);
    },
    isWallTypeSelected() {
      const hasCode = !!this.filters.code;
      return hasCode;
    },
    selectedBufferParamsType() {
      if (!this.selectedRows.length || !this.rowsData.length) return null;

      const selectedData = this.rowsData.filter(item =>
        this.selectedRows.includes(item.floor_buffer_id)
      );

      return { selectedData };
    },
    selectedBufferParams() {
      if (!this.selectedRows.length || !this.rowsData.length) return null;

      const selectedData = this.rowsData.filter(item =>
        this.selectedRows.includes(item.floor_buffer_id)
      );

      const lines = [];

      selectedData.forEach(item => {
        let processedPoints = item.points;

        lines.push({
          ...item,
          floor_param_id: item.floor_buffer_id,
          floor_param_type_color: item.color,
          coord_type: item.coord_type,
          points: processedPoints,
          wall_type_name: item.wall_type_name
        });
      });

      return {
        lines
      };
    },
  },
  methods: {
    async getWallTypes() {
      if (this.filters.floor_field_1 && this.filters.floor_field_2) {
        return;
      }
      const params = {
        code: this.filters.code,
        floor_field_1: this.filters.floor_field_1,
        floor_field_2: this.filters.floor_field_2
      };
      const res = await getWallTypes(params)
      this.wall_type_name = res || []
    },
    async getFloorField1() {
      const res = await getFloorField1({ code: this.filters.code })
      this.floor_field_1 = res || []
    },
    async getFloorField2() {
      const res = await getFloorField2({ code: this.filters.code })
      this.floor_field_2 = res || []
    },
    debouncedCodeChange(value) {
      if (this.codeDebounceTimer) {
        clearTimeout(this.codeDebounceTimer);
      }

      this.codeDebounceTimer = setTimeout(() => {
        this.handleCodeChange(value);
      }, 500);
    },
    handleCodeChange(value) {
      if (value) {
        this.filters.wall_type_names = [];
        this.filters.floor_field_1 = '';
        this.filters.floor_field_2 = '';
        this.wall_type_name = [];
        this.rowsData = [];
        this.selectedRows = [];
        this.allSelected = false;

        this.getFloorField1();
        this.getFloorField2();
      } else {
        this.filters.wall_type_names = [];
        this.filters.floor_field_1 = '';
        this.filters.floor_field_2 = '';
        this.floor_field_1 = [];
        this.floor_field_2 = [];
        this.wall_type_name = [];
        this.rowsData = [];
        this.selectedRows = [];
        this.allSelected = false;
      }
    },
    async getBufferData() {
      if (!this.filters.code || (!this.filters.floor_field_1 && !this.filters.floor_field_2)) {
        return;
      }
      if (this.filters.floor_field_1 && this.filters.floor_field_2) {
        return;
      }
      this.isFetching = true

      const params = { ...this.filters };
      if (params.wall_type_names && params.wall_type_names.length > 0) {
        const quotedItems = params.wall_type_names.map(item => `"${item}"`);
        params.wall_type_names = `[${quotedItems.join(', ')}]`;
      } else {
        delete params.wall_type_names;
      }

      const res = await getRevitBufferParamsList(params)
      this.isFetching = false
      if (!res) {
        return;
      }
      this.savedFilters = { ...this.filters }
      this.rowsData = res.data || res
      this.totalsData = res.totals || {}
      this.selectedRows = [];
      this.allSelected = false;
    },
    onFiltersChange(key, value) {
      if (['code', 'wall_type_names', 'floor_field_1', 'floor_field_2'].includes(key)) {
        this.filters[key] = value
      }
      if (key === 'code') {
        this.debouncedCodeChange(value);
      }
      if (key === 'floor_field_1') {
        this.filters.wall_type_names = [];
        this.wall_type_name = [];
        this.selectedRows = [];
        this.allSelected = false;
        this.rowsData = [];

        if (this.filters.code) {
          this.getWallTypes();
          this.getBufferData()
        }
      }
      if (key === 'floor_field_2') {
        this.filters.wall_type_names = [];
        this.wall_type_name = [];
        this.selectedRows = [];
        this.allSelected = false;
        this.rowsData = [];

        if (this.filters.code) {
          this.getWallTypes();
          this.getBufferData()
        }
      }
      if (key === 'wall_type_names') {
        if (this.filters.code && (this.filters.floor_field_1 || this.filters.floor_field_2)) {
          this.getBufferData()
        }
      }
    },
    onAllCheckClick(value) {
      this.allSelected = value;
      if (value) {
        this.selectedRows = this.rowsData.map(item => item.floor_buffer_id);
      } else {
        this.selectedRows = [];
      }
    },
    onRowCheckClick(floor_buffer_id, value) {
      if (value) {
        this.selectedRows.push(floor_buffer_id);
      } else {
        this.selectedRows = this.selectedRows.filter(id => id !== floor_buffer_id);
      }
      this.allSelected = this.selectedRows.length === this.rowsData.length && this.rowsData.length > 0;
    },
    getPlaceholderMessage() {
      const hasCode = !!this.filters.code;
      const hasFloor1 = !!this.filters.floor_field_1;
      const hasFloor2 = !!this.filters.floor_field_2;

      if (!hasCode) {
        return 'Внесите код и выберите этаж для отображения данных';
      }

      if (hasFloor1 && hasFloor2) {
        return 'Выберите либо один этаж, либо другой. Нельзя выбирать два этажа одновременно.';
      }

      if (hasCode && !hasFloor1 && !hasFloor2) {
        return 'Выберите этаж для отображения данных';
      }

      return 'Загрузка данных...';
    },
    applyNewRows(newRows) {
      this.rowsData = newRows;
      this.selectedRows = [];
      this.allSelected = false;

      if (this.filters.code && (this.filters.floor_field_1 || this.filters.floor_field_2)) {
        this.getWallTypes();

        if (!newRows || newRows.length === 0) {
          this.filters.wall_type_names = [];
        }
      }
    },
    refreshData() {
      this.selectedRows = [];
      this.allSelected = false;

      if (this.filters.code && (this.filters.floor_field_1 || this.filters.floor_field_2)) {
        this.getBufferData();
      }
    },
  },
  beforeUnmount() {
    if (this.codeDebounceTimer) {
      clearTimeout(this.codeDebounceTimer);
    }
  },
  setup() {
    const { showSucceedSnackbar } = useCustomSnackbar();
    return { showSucceedSnackbar };
  },
}
</script>

<style scoped lang="scss">
.wrapper {
  background-color: #FFFFFF;
  box-shadow: #4B5563;
  border-radius: 16px;
}

.wrapper_title {
  margin: 0;
  font-size: 32px;
  font-weight: 600;
  color: #4B5563;
}

:deep(.custom-select .q-field__control) {
  height: 46px !important;
}

:deep(.custom-select .q-field__append) {
  height: 46px !important;
  display: flex !important;
  align-items: center !important;
}

:deep(.q-field__control) {
  min-height: 46px !important;

  &::before {
    min-height: 46px !important;
  }

  &::after {
    min-height: 46px !important;
  }
}

.content-layout {
  display: flex;
  gap: 20px;
}

.table-section {
  width: 60%;
  flex: 0 0 60%;
}

.placeholder-message {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 20px;
  width: 100%;
  height: 400px;
}

.placeholder-text {
  font-size: 16px;
  color: #4B5563;
  line-height: 1.5;
}

.header {
  margin: 16px 0;
  display: flex;
  align-items: flex-end;
  gap: 15px;
  flex-wrap: wrap;

  &__item {
    width: 200px;
  }

  @media (max-width: 400px) {
    &__item {
      width: 100%;
    }
  }
}

.filters__item {
  width: 220px;

  &-label {
    font-size: 13px;
    line-height: 13px;
    margin-bottom: 8px;
  }
}

.q-table tbody td {
  font-size: 10px !important;
}

.popup-proxy {
  padding: 10px;
  width: 400px;
  font-size: 10px;
  color: #4B5563;
}
</style>
